import { render, staticRenderFns } from "./codeConfiguration.vue?vue&type=template&id=119535f8&scoped=true"
import script from "./codeConfiguration.vue?vue&type=script&lang=js"
export * from "./codeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./codeConfiguration.vue?vue&type=style&index=0&id=119535f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119535f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119535f8')) {
      api.createRecord('119535f8', component.options)
    } else {
      api.reload('119535f8', component.options)
    }
    module.hot.accept("./codeConfiguration.vue?vue&type=template&id=119535f8&scoped=true", function () {
      api.rerender('119535f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/codeConfiguration.vue"
export default component.exports